import { PayPalButtonOnShippingChange } from "@paypal/paypal-js"
import { action_getCountries } from "src/actions/checkout"
import { updateCartAddressesOrThrow } from "src/checkout/hooks/useCart"
import { setExpressCheckoutErrorMessage } from "src/checkout/state/checkoutExpressStore"
import { WCUpdateUserAddressRequestData } from "src/data/woocommerce/wcStoreTypes"
import { paypalLogPrefix } from "src/integrations/paypal/constants"
import { mapPayPalAmountToPlainApiFormat, mapToPayPalOrder } from "src/integrations/paypal/mapping"
import { trackAddShippingInfo } from "src/tracking/events"
import { genericErrorMessage } from "src/utilities/errorMessages"
import { recordError } from "src/utilities/errorReporting"

export const payPalButtonOnShippingChange: PayPalButtonOnShippingChange = async (data, actions) => {
  try {
    console.debug(paypalLogPrefix, "onShippingChange", data, actions)

    const paypalAddress = data.shipping_address
    const countryCode = paypalAddress?.country_code

    if (!countryCode) {
      throw new Error("Missing shipping address country code")
    }

    const supportedCountres = await action_getCountries()
    const isSupported = supportedCountres.some((country) => country.code.toUpperCase() === countryCode.toUpperCase())

    if (!isSupported) {
      const shippingCountries = supportedCountres
        .map((country) => country.name)
        .sort()
        .join(", ")

      const errorMessage = `Leider liefern wir nicht nach "${countryCode}". Bitte wähle eine Adresse in einem der folgenden Länder: ${shippingCountries}`

      setExpressCheckoutErrorMessage(errorMessage)

      console.error(paypalLogPrefix, "country not supported", { countryCode })
      // @ts-ignore
      return actions.reject(errorMessage)
    }

    setExpressCheckoutErrorMessage(null)

    const wcAddressChange: WCUpdateUserAddressRequestData = {
      billing_address: {},
      shipping_address: {
        country: paypalAddress.country_code,
        state: paypalAddress.state.toLowerCase().includes("empty") ? "" : paypalAddress.state,
        postcode: paypalAddress.postal_code,
        city: paypalAddress.city,
      },
    }

    console.debug(paypalLogPrefix, "updating cart address...", wcAddressChange)
    const newCart = await updateCartAddressesOrThrow(wcAddressChange)
    console.debug(paypalLogPrefix, "country supported", { countryCode })

    trackAddShippingInfo(newCart)

    const newPayPalOrderRequest = mapToPayPalOrder(newCart)
    const newAmount = newPayPalOrderRequest.purchaseUnits[0]!.amount
    console.debug(paypalLogPrefix, "cart amount changed", { newAmount })

    await actions.order.patch([
      {
        op: "replace",
        path: "/purchase_units/@reference_id=='default'/amount",
        value: mapPayPalAmountToPlainApiFormat(newAmount),
      },
    ])
  } catch (error) {
    recordError(paypalLogPrefix + " Failed to handle onShippingChange", error)
    setExpressCheckoutErrorMessage(genericErrorMessage)
    await actions.reject()
  }
}
